import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "mb-2" }
const _hoisted_2 = { class: "list list-scrollbar" }

import ListHeader from '@/components/GpsTrackerSetting/ListHeader.vue';
import ListRow from '@/components/GpsTrackerSetting/ListRow.vue';
import getGpsTrackerSettingResponse from '@/types/responses/getGpsTrackerSetting'


export default /*@__PURE__*/_defineComponent({
  __name: 'GpsTrackerSettingTable',
  props: {
    isLoading: { type: Boolean },
    gpsTrackerSettings: {},
    showDeleteButton: { type: Boolean }
  },
  emits: ["delete"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

function onDelete(id: number) {
  emit('delete', id)
}

return (_ctx: any,_cache: any) => {
  const _component_v_table = _resolveComponent("v-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_table, null, {
        default: _withCtx(() => [
          _createVNode(ListHeader),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.gpsTrackerSettings, (gpsTrackerSetting) => {
            return (_openBlock(), _createBlock(ListRow, {
              key: gpsTrackerSetting.id,
              gpsTrackerSetting: gpsTrackerSetting,
              showDeleteButton: props.showDeleteButton,
              onDelete: onDelete
            }, null, 8, ["gpsTrackerSetting", "showDeleteButton"]))
          }), 128))
        ]),
        _: 1
      })
    ])
  ]))
}
}

})